import React, { useState, useEffect } from 'react';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('home');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section');
      const scrollPosition = window.scrollY + 100;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute('id');

        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight && sectionId) {
          setActiveLink(sectionId);
        }
      });

      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 70,
        behavior: 'smooth'
      });
      setActiveLink(sectionId);
      closeMenu();
    }
  };

  return (
    <header className={`fixed w-full top-0 left-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white header-shadow py-3' : 'bg-transparent py-5'}`}>
      <div className="container mx-auto px-4">
        <nav className="flex justify-between items-center">
          <a 
            href="#" 
            onClick={() => scrollToSection('home')} 
            className={`text-2xl font-bold ${isScrolled ? 'text-gray-800' : 'text-white'}`}
          >
            <span className="text-primary">Stack</span>Studio
          </a>
          
          {/* Desktop Navigation */}
          <ul className="hidden md:flex space-x-8">
            <li>
              <a
                href="#home"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('home');
                }}
                className={`nav-link ${activeLink === 'home' ? 'active text-primary' : isScrolled ? 'text-gray-800' : 'text-white'}`}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('about');
                }}
                className={`nav-link ${activeLink === 'about' ? 'active text-primary' : isScrolled ? 'text-gray-800' : 'text-white'}`}
              >
                About
              </a>
            </li>
            <li>
              <a
                href="#portfolio"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('portfolio');
                }}
                className={`nav-link ${activeLink === 'portfolio' ? 'active text-primary' : isScrolled ? 'text-gray-800' : 'text-white'}`}
              >
                Portfolio
              </a>
            </li>
            <li>
              <a
                href="#services"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('services');
                }}
                className={`nav-link ${activeLink === 'services' ? 'active text-primary' : isScrolled ? 'text-gray-800' : 'text-white'}`}
              >
                Services
              </a>
            </li>
            <li>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('contact');
                }}
                className={`nav-link ${activeLink === 'contact' ? 'active text-primary' : isScrolled ? 'text-gray-800' : 'text-white'}`}
              >
                Contact
              </a>
            </li>
          </ul>
          
          {/* Mobile Navigation Toggle */}
          <button
            className="md:hidden text-2xl focus:outline-none"
            onClick={toggleMenu}
          >
            <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'} ${isScrolled ? 'text-gray-800' : 'text-white'}`}></i>
          </button>
        </nav>
        
        {/* Mobile Navigation Menu */}
        <div className={`md:hidden transition-all duration-300 overflow-hidden ${isMenuOpen ? 'max-h-screen opacity-100 mt-4' : 'max-h-0 opacity-0'}`}>
          <ul className="bg-white rounded-lg shadow-lg py-3">
            <li>
              <a
                href="#home"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('home');
                }}
                className={`block py-2 px-4 ${activeLink === 'home' ? 'text-primary' : 'text-gray-800'}`}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('about');
                }}
                className={`block py-2 px-4 ${activeLink === 'about' ? 'text-primary' : 'text-gray-800'}`}
              >
                About
              </a>
            </li>
            <li>
              <a
                href="#portfolio"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('portfolio');
                }}
                className={`block py-2 px-4 ${activeLink === 'portfolio' ? 'text-primary' : 'text-gray-800'}`}
              >
                Portfolio
              </a>
            </li>
            <li>
              <a
                href="#services"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('services');
                }}
                className={`block py-2 px-4 ${activeLink === 'services' ? 'text-primary' : 'text-gray-800'}`}
              >
                Services
              </a>
            </li>
            <li>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('contact');
                }}
                className={`block py-2 px-4 ${activeLink === 'contact' ? 'text-primary' : 'text-gray-800'}`}
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;